import React, { useEffect, useState } from 'react';
import OnboardingTour from './index';
import { TourData } from './types';

interface SafeOnboardingTourProps {
  isOpen: boolean;
  tourData: TourData | null;
  onComplete: () => void;
  onSkip: () => void;
}

const SafeOnboardingTour: React.FC<SafeOnboardingTourProps> = (props) => {
  const [isReady, setIsReady] = useState(false);
  
  useEffect(() => {
    if (!props.isOpen || !props.tourData) {
      setIsReady(false);
      return;
    }

    // Wait for DOM to be ready and check if target elements exist
    const checkTargetElements = () => {
      try {
        const firstStep = props.tourData?.steps?.[0];
        if (!firstStep) {
          return false;
        }

        const targetElement = document.querySelector(firstStep.target);
        return targetElement !== null;
      } catch (error) {
        console.warn('SafeOnboardingTour: Error checking target elements', error);
        return false;
      }
    };

    // Check immediately
    if (checkTargetElements()) {
      setIsReady(true);
      return;
    }

    // If not ready immediately, check again after a delay
    const timer = setTimeout(() => {
      if (checkTargetElements()) {
        setIsReady(true);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [props.isOpen, props.tourData]);

  if (!isReady || !props.isOpen || !props.tourData) {
    return null;
  }

  return <OnboardingTour {...props} />;
};

export default SafeOnboardingTour;